export const MenuType = {
  YEAR: 'year',
  MONTH: 'month',
  DATE: 'date',
};
